import firebase from 'firebase'
import {firestore, query, collection, where, getAll} from 'firebase/firestore';
import {db, auth} from '../db';
import PlaytestInfoVue from '../components/playtest/Playtest-Info.vue';
import PlayTesterUser from './PlayTesterUser';
import Chat from "@/Firestore/Chat.js";
import Notifications from "./Notifications";
import Events from "./Events";

function err(e) {
  return {success: false, error: e};
}

function notifyProjectCreated(gameName, company, developerName) {
  Notifications.createRoleNotification(
    2,
    "project-created",
    "New project created",
    "",
    {
      projectName: gameName || "Untitled project",
      studioName: company || "",
      developerName: developerName || "Unknown developer",
    }
  ).catch(e => console.log(e));
}

// GameInfoEdit.vue
/*
  Updates a game project of the gameId. 
  If gameId is not given, creates a new game project.
*/
async function createProject(gameId, developerID, gameName, company, img, endTime, description, qaLead, platform = [], playtestInstructions = [], behavior = [], genre = []){
    return new Promise((resolve, reject) => {
      if (gameId === "-1") {
        const newGameRef = db.collection("Game").doc();
        newGameRef.set({
          developerID: developerID,
          gameName,
          company,
          img,
          endTime,
          description,
          qaLead,
          platform,
          behavior,
          genre,
          questionnaireIDs: [],
          status: 0,
          testerIDs: [],
          testerStatuses: [],
          playPeriods: [],
          playtestInstructions: [...playtestInstructions],
          playtestSessionIDs: [],
        })
        .then(() => {
          Chat.getUserInfo(developerID)
            .then(res => notifyProjectCreated(gameName, company, res.data.userName || res.data.nickName || res.data.email))
            .catch(() => notifyProjectCreated(gameName, company, null));
          Events.logEvent("project.created", { gameId: newGameRef.id, developerID });
          resolve({success: true});
        })
        .catch(e => reject(err(e)));
      } else {
        db.collection("Game").doc(gameId).get().
        then(doc => {
          if (!doc.exists) {
            reject({success: false, error: "game does not exist"});
          }
          db.collection("Game").doc(gameId).update({
            developerID: developerID,
            gameName,
            company,
            img,
            endTime,
            description,
            qaLead,
            platform,
            playtestInstructions,           //I am not sure if this is needed
            behavior,
            genre,
          })
          .then(() => {
            Events.logEvent("project.updated", { gameId, developerID });
            resolve({success: true})
          })
          .catch(e => reject(err(e)))
        })
        .catch(e => reject(err(e)))
      }
    });
}

async function updateProject(gameId, updatedData) {
    return new Promise((resolve, reject) => {
      db.collection("Game").doc(gameId).get()
      .then(doc => {
        if (!doc.exists) {
          reject({success: false, error: "game does not exist"});
          return;
        }
        db.collection("Game").doc(gameId).update(updatedData)
        .then(() => resolve({success: true}))
        .catch(e => reject(err(e)));
      })
      .catch(e => reject(err(e)));
    });
}

async function attachPlayPeriodToProject(gameId, playPeriod) {
    return new Promise((resolve, reject) => {
        db.collection("Game").doc(gameId).get()
        .then(doc => {
            if(!doc.exists) {
                reject({success: false, error: "Game does not exist."});
            }
            db.collection("Game").doc(gameId).update({
                playPeriods : firebase.firestore.FieldValue.arrayUnion(playPeriod),
            })
            resolve({success: true});
        })
        .catch(e => reject(err(e)))
    })
}

async function updateTestersToPlayPeriod(playPeriodID, testerIDs) {
    return new Promise((resolve, reject) => {
        db.collection("playPeriod").doc(playPeriodID).get()
        .then(doc => {
            if(!doc.exists) {
                reject({success:false, error: "PlayPeriod does not exist!"});
            }
            db.collection("playPeriod").doc(playPeriodID).update({
              testerIDs: testerIDs,
              testerStatuses: new Array(testerIDs.length).fill(0),
            })
            .then(() => resolve({success: true}))
            .catch(e => reject(err(e)));
        })
        .catch(e => reject(err(e)));
    })
}

async function editTimesOfPlayPeriod(playPeriodID, start, end) {
    const startT = new Date(start + "T00:00:00");
    const endT = new Date(end + "T00:00:00");

    return new Promise((resolve, reject) => {
        db.collection("playPeriod").doc(playPeriodID).get()
        .then(doc => {
            if(!doc.exists) {
                reject({success: false, error: "PlayPeriod does not exist!"});
            }
            db.collection("playPeriod").doc(playPeriodID).update({
                startTime: start,
                endTime: end,
            })
        })
    })
}

async function editStatusOfPlayPeriod(playPeriodID, status) {
    return new Promise((resolve, reject) => {
        db.collection("playPeriod").doc(playPeriodID).get()
        .then(doc => {
            if(!doc.exists) {
            reject({success: false, error: "PlayPeriod does not exist!"});
            }
            db.collection("playPeriod").doc(playPeriodID).update({
                status: status
            })
            console.log("PlayPeriod status altered to: ", status);
        })
        resolve({success: true});
    })
}
/*/// Creation of playtest data from users(playtesters) ///*/
async function userTestSession(){

}

// *** FIXED: capture the new doc ref before calling .set() so we can
// return the new playPeriodId to the caller (needed to assign testers).
async function createPlaytestPeriod(
    playPeriodID,
    gameId,
    developerID,
    tags,
    questions,
    instructions,
    startTime,
    endTime,
    description,
    playtestName,
    transcription,
    link
) {
    return new Promise((resolve, reject) => {
        console.log("playPeriod: ", playPeriodID);
        console.log("gameId: ", gameId);
        console.log("developerID: ", developerID);
        console.log("tags: ", tags);
        console.log("instructions: ", instructions);
        console.log("questions: ", questions);
        console.log("startTime and endTime: ", startTime, "|", endTime);
        console.log("description: ", description);
        console.log("transcription: ", transcription);
        console.log("link: ", link);

        // create new play period | if playPeriod === -1, create new playPeriod. Else, edit.
        if (playPeriodID === "-1") {
            // Capture the ref BEFORE .set() so we can return its ID
            const newDocRef = db.collection("playPeriod").doc();

            newDocRef.set({
                developerID: developerID,
                gameID: gameId,
                tags: tags,
                questions: questions,
                startTime: startTime,
                endTime: endTime,
                instructions: instructions,
                description: [description],
                transcription: transcription,
                link: link,
                testerIDs: [],
                testerStatuses: [],
                userTestIDs: [],
                name: playtestName,
                status: 0
            })
            .then(() => {
                resolve({
                    success: true,
                    playPeriodId: newDocRef.id
                });
            })
            .catch(e => reject(err(e)));

        } else {

            db.collection("playPeriod").doc(gameId).get()
            .then(doc => {

                if (!doc.exists) {
                    reject({
                        success: false,
                        error: "playPeriod does not exist"
                    });
                    return;
                }

                db.collection("playPeriod").doc(playPeriodID).update({
                    developerID: developerID,
                    gameID: gameId,
                    startTime: startTime,
                    endTime: endTime,
                    description: [description],
                    name: playtestName,
                    transcription: transcription,
                    link: link
                })
                .then(() => {
                    resolve({
                        success: true,
                        playPeriodId: playPeriodID
                    });
                })
                .catch(e => reject(err(e)));

            })
            .catch(e => reject(err(e)));
        }
    });
}

async function getPlayTestPeriods(gameId) {
    return new Promise((resolve, reject) => {
        db.collection("playPeriod").where("gameID", "==", gameId).get()
        .then(querySnapshot => {
            if(querySnapshot.empty) {
                reject({success: false, error: "playPeriod not found."});
            } else {
                let periods = [];
                querySnapshot.forEach(doc => {
                    let period = {
                        gameID : doc.data().gameID,
                        tags : doc.data().tags,
                        startTime : doc.data().startTime,
                        endTime : doc.data().endTime,
                        description: doc.data().description,
                        name : doc.data().name,
                        status: doc.data().status,
                        testerIDs: doc.data().testerIDs,
                        playPeriodID: doc.id
                    };
                    periods.push(period)
                })
                resolve({success: true, data: periods});
            }
        })
    })
}

export async function deletePlayPeriod(periodID) {
    return new Promise((resolve, reject) => {
        console.log(periodID);
        db.collection("playPeriod").doc(periodID).get()
        .then(doc => {
            if(!doc.exists) {
                reject({success: false, error: "Play Period does not exist!"})
            }
        })
        db.collection("playPeriod").doc(periodID).delete()
            .then(() => {console.log("PlayPeriod deleted... :(")}).catch(e => reject(err(e)));
            resolve({success: true});
    })
}

export async function deleteGame(gameId) {
    return new Promise((resolve, reject) => {
        let developerID = '';
        db.collection("Game").doc(gameId)
        .get()            
        .then(doc => {
            console.log(doc.exists);
            if (!doc.exists) {
                console.log("game doesn't exist");
                reject({success: false, error: "game doesn't exist"});  
            }
            developerID = doc.data().developerID
        }).catch(e => reject(err(e)));
  
        db.collection("Game").doc(gameId).delete()
        .then(() => { console.log("Game deleted")}).catch(e => reject(err(e)));
  
        db.collection("Timeslot")
        .where("gameID", "==", gameId)
        .get()
        .then(docs => {
            docs.forEach(doc => {
                db.collection("Timeslot").doc(doc.id).delete()
                .then(() => { console.log("Deleted a timeslot")})
                .catch(e => reject(err(e)));
            })
        }).catch(e => reject(err(e)));
  
        db.collection("Survey")
        .where("gameID", "==", gameId)
        .get()
        .then(surveys => {
            surveys.forEach(survey => {
                survey.ref.delete()
                    .then(() => { console.log("Deleted a survey") })
                    .catch(e => reject(err(e)));
            })
        })
        .catch(e => reject(err(e)));
  
        resolve({success: true});
    })
}

async function getTestersFromProject(gameId) {
    return new Promise((resolve, reject) => {
        db.collection("Game").where(firebase.firestore.FieldPath.documentId(), "==", gameId).get()
        .then(querySnapshot => {
            if(querySnapshot.empty) {
                reject({success:false, error: "Game not found"});
            } else {
                querySnapshot.forEach(doc => {
                    const retTesters = {
                        testerIds: doc.data().testerIDs
                    };
                console.log(retTesters);
                resolve({success:true, data:retTesters});
                });
            }
        })
    })
}

async function getProject(gameId){
    return new Promise((resolve, reject) => {
          db.collection("Game").where(firebase.firestore.FieldPath.documentId(), "==", gameId).get()
          .then(querySnapshot => {
              if (querySnapshot.empty) {
                  reject({success: false, error: "the game was not found"});
              } else {
                  querySnapshot.forEach(doc => {
                      const newProject = {
                          testerIds: doc.data().testerIDs,
                          testerStatuses: doc.data().testerStatuses,
                          description: doc.data().description,
                          img: doc.data().img,
                          company: doc.data().company,
                          gameName: doc.data().gameName,
                          qaLead: doc.data().qaLead,
                          gameId: doc.id,
                          developerID: doc.data().developerID,
                          playPeriod: doc.data().playPeriod,
                          platform: doc.data().platform || [],
                          behavior: doc.data().behavior || [],
                          genre: doc.data().genre || [],
                      };
                      resolve({success: true, data: newProject});
                  });
              }
          })
          .catch(e => reject(err(e)));
      });
  }

async function getCalendar(userId, queryTime) {
    function err(e) {
        return {success: false, error: e};
    }

    function nextMonth(yearmonth) {
        const [inputYear, inputMonth] = yearmonth.split("-");
        let newYear = inputYear;
        let newMonth = "";
        if (+inputMonth==12) {
            newMonth="01";
            newYear=`${+newYear+1}`;
        } else if (+inputMonth < 9) {
            newMonth=`0${+inputMonth+1}`;
        } else {
            newMonth=`${+inputMonth+1}`;
        }
        return parseInt(`${newYear}${newMonth}`);
    }

    return new Promise((resolve, reject) => {
        if (userId==="") {
            db.collection("Game").get()
            .then(querySnapshot => {
                if (querySnapshot.empty) {
                    reject({success: false, error: "no games found for admin"});
                } else {
                    let res = [];
                    querySnapshot.forEach(doc => {
                        let nextYearMonth = nextMonth(doc.data().endTime);
                        const [endYear, endMonth] = doc.data().endTime.split("-");
                        const endTime = parseInt(`${endYear}${endMonth}`);
                        const [queryYear, queryMonth] = queryTime.split("-");
                        const queryTimeInt = parseInt(`${queryYear}${queryMonth}`);
                        if (endTime < nextYearMonth && endTime > queryTimeInt) {
                            const testerIDsLength = doc.data().testerIDs ? doc.data().testerIDs.length : 0;
                            let newDoc = {
                                gameName: doc.data().gameName,
                                gameStudio: doc.data().company,
                                endTime: doc.data().endTime,
                                img: doc.data().img,
                                gameId: doc.id,
                                devId: doc.data().developerID,
                                testerNum: testerIDsLength,
                            }
                            res.push(newDoc);
                        }
                    });
                    resolve({success: true, data: res});
                }
            }).catch(e => reject(err(e)));
        } else {
            db.collection("Game").where("developerID", "==", userId).get()
            .then(querySnapshot => {
                if (querySnapshot.empty) {
                    reject({success: false, error: "no games found for this developer"});
                } else {
                    let res = [];
                    querySnapshot.forEach(doc => {
                        let nextYearMonth = nextMonth(doc.data().endTime);
                        const [endYear, endMonth] = doc.data().endTime.split("-");
                        const endTime = parseInt(`${endYear}${endMonth}`);
                        const [queryYear, queryMonth] = queryTime.split("-");
                        const queryTimeInt = parseInt(`${queryYear}${queryMonth}`);
                        if (endTime < nextYearMonth && endTime > queryTimeInt) {
                            const testerIDsLength = doc.data().testerIDs ? doc.data().testerIDs.length : 0;
                            let newDoc = {
                                gameName: doc.data().gameName,
                                gameStudio: doc.data().company,
                                endTime: doc.data().endTime,
                                img: doc.data().img,
                                gameId: doc.id,
                                devId: doc.data().developerID,
                                testerNum: testerIDsLength,
                            }
                            res.push(newDoc);
                        }
                    });
                    resolve({success: true, data: res});
                }
            }).catch(e => reject(err(e)));
        }
    });
}

async function getTesterCalendar(userId, queryTime) {
    function err(e) {
        return {success: false, error: e};
    }

    function nextMonth(yearmonth) {
        const [inputYear, inputMonth] = yearmonth.split("-");
        let newYear = inputYear;
        let newMonth = "";
        if (+inputMonth==12) {
            newMonth="01";
            newYear=`${+newYear+1}`;
        } else if (+inputMonth < 9) {
            newMonth=`0${+inputMonth+1}`;
        } else {
            newMonth=`${+inputMonth+1}`;
        }
        return parseInt(`${newYear}${newMonth}`);
    }

    return new Promise(async (resolve, reject) => {
        if (userId==="") {
            reject(err("User is not a tester"));
        } else {
            let calendarList = [];
            let sectionObj = {};
            await db.collection("Timeslot").where("testerID", "==", userId).get()
            .then(querySnapshot => {
                if (querySnapshot.empty) {
                    resolve({success: true, data: []});
                } else {
                    for (const doc of querySnapshot.docs) {
                        for (const slot of doc.data().timeslot) {
                            const startTimestamp = slot.startTime;
                            const queryTimestamp = Date.parse((queryTime+"-01 00:00:00"))/1000;
                            const nextMonthTimestamp = Date.parse(nextMonth(queryTime)+"-01 00:00:00")/1000;
                            if (startTimestamp > queryTimestamp && startTimestamp < nextMonthTimestamp) {
                                if (sectionObj[doc.data().gameID]) {
                                    sectionObj[doc.data().gameID].push(slot);
                                } else {
                                    sectionObj[doc.data().gameID] = [slot];
                                }
                            }
                        };
                    }
                }
            }).catch(e => reject(err(e)));
            for (const key in sectionObj) {
                const section = sectionObj[key];
                if (section.length) {
                    await db.collection("Game").where(firebase.firestore.FieldPath.documentId(), "==", key).get()
                    .then(querySnapshot2 => {
                        if (querySnapshot2.empty) {
                            resolve({success: true, data: []});
                        } else {
                            for (const game of querySnapshot2.docs) {
                                const testerIDsLength = game.data().testerIDs ? game.data().testerIDs.length : 0;
                                let newGame = {
                                    gameId: game.id,
                                    gameName: game.data().gameName,
                                    img: game.data().img,
                                    endTime: game.data().endTime,
                                    devId: game.data().developerID,
                                    testerNum: testerIDsLength,
                                    timeSlots: section,
                                }
                                calendarList.push(newGame);
                            };
                        }
                    })
                    .catch(e => reject(err(e)));
                }
            }
            resolve({success: true, data: calendarList});
        }
    });
}

async function getTesterProjects(testerId) {
    return new Promise((resolve, reject) => {
        db.collection("Game").where("testerIDs", "array-contains", testerId).get()
        .then(querySnapshot => {
            if (querySnapshot.empty) {
                reject({success: false, error: "No projects found"});
            } else {
                let docs = [];
                querySnapshot.forEach(doc => {
                    let testerStatus = doc.data().testerIDs.indexOf(testerId)
                    let newDoc = {
                      gameId: doc.id,
                      devId: doc.data().developerID,
                      gameName: doc.data().gameName,
                      gameStudio: doc.data().company,
                      endTime: doc.data().endTime,
                      img: doc.data().img,
                      description: doc.data().description,
                      qaLead: doc.data().qaLead,
                      questionnaireIDs: doc.data().questionnaireIDs,
                      status: doc.data().testerStatuses !== undefined ? doc.data().testerStatuses[testerStatus] : -1,
                      platform: doc.data().platform || [],
                      behavior: doc.data().behavior || [],
                      genre: doc.data().genre || [],
                    }
                    docs.push(newDoc);
                });
                resolve({success: true, data: docs});
            }
        })
        .catch(e => reject({success: false, error: e}));
    });
}
  
async function getDevProjects(devId) {
    return new Promise((resolve, reject) => {
        db.collection("Game").where("developerID", "==", devId).get()
        .then(querySnapshot => {
            if (querySnapshot.empty) {
                reject({success: false, error: "No projects found"});
            } else {
                let docs = [];
                querySnapshot.forEach(doc => {
                    let newDoc = {
                    gameId: doc.id,
                    devId: doc.data().developerID,
                    gameName: doc.data().gameName,
                    gameStudio: doc.data().company,
                    endTime: doc.data().endTime,
                    img: doc.data().img,
                    description: doc.data().description,
                    qaLead: doc.data().qaLead,
                    questionnaireIDs: doc.data().questionnaireIDs,
                    platform: doc.data().platform || [],
                    behavior: doc.data().behavior || [],
                    genre: doc.data().genre || [],
                    }
                    docs.push(newDoc);
                });
                resolve({success: true, data: docs});
            }
        })
        .catch(e => reject({success: false, error: e}));
    });
}

async function getAllProjects() {
    return new Promise((resolve, reject) => {
        db.collection("Game").get()
        .then(querySnapshot => {
            if (querySnapshot.empty) { 
                reject({success: false, error: "No projects found"});
            } else {
                let projects = [];
                querySnapshot.forEach(doc => {
                    let project = {
                        gameId: doc.id,
                        devId: doc.data().developerID,
                        gameName: doc.data().gameName,
                        gameStudio: doc.data().company,
                        endTime: doc.data().endTime,
                        img: doc.data().img,
                        description: doc.data().description,
                        qaLead: doc.data().qaLead,
                        questionnaireIDs: doc.data().questionnaireIDs,
                        testerIDs: doc.data().testerIDs,
                        platform: doc.data().platform || [],
                        behavior: doc.data().behavior || [],
                        genre: doc.data().genre || [],
                    };
                    projects.push(project);
                });
                resolve({success: true, data: projects});
            }
        })
        .catch(e => reject({success: false, error: e}));
    });
}

export async function joinProject(gameId, userId) {
  try {
    const gameRef = db.collection("Game").doc(gameId);
    const gameDoc = await gameRef.get();

    if (!gameDoc.exists) {
      return { success: false, message: "Project not found." };
    }

    const gameData = gameDoc.data();
    const updatedTesterIDs = [...(gameData.testerIDs || []), userId];
    await gameRef.update({ testerIDs: updatedTesterIDs });

    Events.logEvent("project.joined", { gameId, testerId: userId });

    const developerId = gameData.developerID || gameData.devID || gameData.ownerID;

    if (!developerId) {
      console.warn("⚠ No developerID found in game data.");
      return { success: true, message: "Successfully joined the project!" };
    }

    const testerDoc = await db.collection("User").doc(userId).get();
    const testerData = testerDoc.exists ? testerDoc.data() : {};
    const testerName = testerData.nickName || testerData.userName || "Tester";

    const notification = {
      type: "testerJoined",
      projectId: gameId,   
      projectName: gameData.gameName,
      projectImg: gameData.gameImage || gameData.coverImage || gameData.img || null,
      testerId: userId,
      testerName,
      testerAvatar: testerData.img || testerData.avatar || null,
      timestamp: new Date(),
      unread: true
    };

    await db
      .collection("UserNotifications")
      .doc(developerId)
      .collection("Notifications")
      .add(notification);

    return { success: true, message: "Successfully joined the project!" };

  } catch (error) {
    console.error("Error joining project:", error);
    return { success: false, message: "Error joining the project." };
  }
}

export default {
  createProject,
  updateProject,
  attachPlayPeriodToProject,
  updateTestersToPlayPeriod,
  editStatusOfPlayPeriod,
  getPlayTestPeriods,
  deletePlayPeriod,
  createPlaytestPeriod,
  deleteGame,
  getTestersFromProject,
  getProject,
  getCalendar,
  getTesterCalendar,
  getTesterProjects,
  getDevProjects,
  getAllProjects,
}


// WEBPACK FOOTER //
// ./src/Firestore/GamesObject.js